














import VueFramework from 'vue'
import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
import ChannelApi from "../../repository/ChannelApi";
import {TopicApi} from "../../repository/TopicApi";
@Component({
    components: {


    },
    name: 'DeleteTopicModal',
})
export default class DeleteTopicModal extends Vue{
    @Prop({ default: false })showDialog!:boolean
    @Prop({ default: '' })topicName!:string
    @Prop({ default: '' })topicId!:string
    topicApi: TopicApi = new TopicApi()
    closeModal(){
        this.$emit('cancelModal')
    }
    async deleteTopic(){
        let response = await this.topicApi.deleteTopic(this.topicId)
        this.$emit('onTopicDeleted', response)
    }
}
